import isApiError from "@insite/client-framework/Common/isApiError";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addWishListLines } from "@insite/client-framework/Services/WishListService";
import { AddLineToWishList, chain } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";

replaceInChain(chain, AddLineToWishList, async props => {
    if (!props.result.wishList) {
        return;
    }

    try {
        const lines = props.parameter.productInfos.map((productInfo: any) => ({
            productId: productInfo.productId,
            qtyOrdered: productInfo.qtyOrdered,
            unitOfMeasure: productInfo.unitOfMeasure,
            notes: productInfo.notes,
        }));
        await addWishListLines({ wishList: props.result.wishList, lines });
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        if (error?.status === 404) {
            props.result.errorMessage = error.errorMessage;
            return;
        }
        throw error;
    }
});
